// extracted by mini-css-extract-plugin
module.exports = {"pathFill":"LoadingSpinner_pathFill__HkQsH","dash":"LoadingSpinner_dash___9lQe"};